import React from 'react';
import CompanyUsersContainer from './CompanyUsersContainer';

const CompanyUsersPage = () => <CompanyUsersContainer />;

export default CompanyUsersPage;
